import React, { useContext, useEffect } from 'react'
import MobileNavbar from '../../components/MobileNavbar';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/Header';
import { AuthContext } from '../../contexts/AuthContext';
import { connect_stripe_account, get_account_setup_link, get_stripe_customer_account_info } from '../../API/user';
import { useParams, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Button } from '@mui/material';

function StripeConnect() {
    const { authAxios, user } = useContext(AuthContext);
    const [stripeAccountId, setStripeAccountId] = React.useState(user.stripe_account_id);
    const [searchParams] = useSearchParams();
    const [stripeAccountInfo, setStripeAccountInfo] = React.useState(null);

  

    useEffect(() => {
        const connectedAccountId = searchParams.get('connected_account_id');
        const isReturn = searchParams.get('return');

        if (!connectedAccountId) {
            return;
        }

        if (connectedAccountId) {
            get_stripe_customer_account_info(authAxios, connectedAccountId).then((res)=>{
                console.log('Stripe Account Info:', res.data);
                setStripeAccountInfo(res?.data?.account);
                console.log("res?.data?.account", res?.data?.account)
            })
        }

        if(isReturn){
            setStripeAccountId(connectedAccountId);
        }
    }, [searchParams]);

    
    const handleConnect = async () => {
        // Logic to connect with Stripe
        // call customer/connect_account api 
        try {
            let formData = new FormData();
            formData.append('email', user.email);
            const res = await connect_stripe_account(authAxios, formData);
            const url = res.data.url;
            // Redirect to Stripe Connect URL
            window.location.href = url;
        } catch (error) {
            toast.error('Error connecting to Stripe:', error);
        }
    }

    const handleSetupAccount = async (connectedAccountId) => {
        // Logic to get account Id
        // call customer/get_account_id api 
        try {
            let formData = new FormData();
            formData.append('stripe_account_id', connectedAccountId);
            const res = await get_account_setup_link(authAxios, formData);
            console.log('Account Setup Link:', res.data);
            if (res.status !== 200) {
                console.log('Error getting account setup link:', res);
                toast.error('Error getting account setup link:', res.error);
                return;
            }
            // res.data.url redirect to the url
            window.location.href = res.data.url;
        } catch (error) {
            console.log("Error", error)
            toast.error('Error getting account setup link:', error);
        }
    }

    // if account_id= True and success = True -> Show account id
    // if account_id= True and success = False -> Show connect again prompt
    // if account_id= False and success = False -> Show connect button

    return (
        <div className='hero_content theme_content'>
            <div className="pagewrapper userBasicDetail">
                <h3 style={{marginBottom: 40}}>Stripe Connect</h3>
                {stripeAccountId && stripeAccountInfo?.details_submitted ? (
                    <div className="stripe_connect_success">
                        <p>Your Stripe account is connected successfully!</p>
                        <p>Account ID: {stripeAccountId}</p>
                    </div>
                ) : stripeAccountId && !stripeAccountInfo?.details_submitted ? (
                    <div className="stripe_connect_error">
                        <p>Your Stripe account is connected but It's not fully setup.</p> 
                        <p>Account ID: <code>{stripeAccountId}</code></p>
                        <p>Please complete the setup process.</p>
                        <Button variant='contained'  onClick={() => handleSetupAccount(stripeAccountId)}>Setup Again</Button>
                    </div>
                ) : (
                    <Button variant='contained' onClick={() => handleConnect()}>Connect with Stripe</Button>
                )}
            </div>
        </div>
    )
    
}

export default StripeConnect